export default __webpack_public_path__ + "static/media/after@2x.53f5620f.png";